import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../config/firebase';

export default function VerifyCompletePage() {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    const go = async () => {
      try {
        const user = auth.currentUser;
        if (user) {
          await user.reload();
          const refreshed = auth.currentUser;
          if (!cancelled) {
            if (refreshed?.emailVerified) {
              navigate('/library', { replace: true });
            } else {
              navigate('/verify-email', { replace: true });
            }
          }
        } else {
          navigate('/verify-email', { replace: true });
        }
      } catch (e) {
        navigate('/verify-email', { replace: true });
      }
    };
    go();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-600 mx-auto mb-4"></div>
        <p className="text-gray-700">Finalizing verification...</p>
      </div>
    </div>
  );
}
